import { render, staticRenderFns } from "./RegistrationImage.vue?vue&type=template&id=2caf8e08&scoped=true"
import script from "./RegistrationImage.vue?vue&type=script&lang=js"
export * from "./RegistrationImage.vue?vue&type=script&lang=js"
import style0 from "./RegistrationImage.vue?vue&type=style&index=0&id=2caf8e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf8e08",
  null
  
)

export default component.exports